export default __webpack_public_path__ + "static/media/Sammy.074eee9d.png";